import React from "react";
import Header from "./header";
import Body from "./body";
import Footer from "./footer";
const EasyGame = () => {
  return (
    <div>
      <Header />
      <Body />
      <Footer />
    </div>
  );
};

export default EasyGame;
